export const FDR_LINK = "https://racing.fanduel.com";
export const USGSA_TRACK_SOURCE = "USGSA";

export const viewOptions = {
  ALL: "All Tracks",
  US: "USA",
  INTERNATIONAL: "International",
};

export const HR_DESCRIPTION =
  "Stay up to date with the latest news, information and updates on Horse Racing. Get all the insights on horse racing odds, picks & predictions";
